import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { EMRService } from '../EMR.service';
import * as moment from "moment";
@Component({
  selector: 'app-oldcase',
  templateUrl: './oldcase.component.html',
  styleUrls: ['./oldcase.component.scss']
})
export class OldcaseComponent implements OnInit {
  oldsummerydata: any;
  getoldsummery: any = {};
  @ViewChild('canvas', { static: false }) public canvas: ElementRef;

  @Input() public width = 200;
  @Input() public height = 200;
  constructor(public dialog: MatDialog, public emrService: EMRService, public opdvisitService: OpdVisitService, public dashboardService: DashboardService) { }

  ngOnInit(): void {
    console.log(this.opdvisitService.patientdetails.pkRegId)
    this.getOldSummeryData();
  }
  closedialog() {
    this.dialog.closeAll();
  }
  cleardrawings() {
   this.oldsummerydata =null;
  }

  savecanvas() {
  
    if (this.oldsummerydata != null && this.oldsummerydata != undefined) {
      if (this.opdvisitService.patientdetails.pkRegId > 0) {
        try {
          if (this.getoldsummery.pK_TranId > 0) {
            let payloaddata = {
              "PK_TranId": this.getoldsummery.pK_TranId,
              "FK_RegId": this.opdvisitService.patientdetails.pkRegId,
              "OLDSummary": this.oldsummerydata +'\n'+ moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("DD/MM/YYYY, HH:mm")+' by '+ sessionStorage.getItem('userName'),
              "Remarks": null,
              "IsEdit": 1
            }
            this.emrService.insertOldSummery(payloaddata).subscribe(
              (data: any) => {
                if (data == null) {
                  throw 'Empty response';
                } else {
                  if (data.statusCode == 1) {

                    this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
                    this.getOldSummeryData();
                  }

                }
              },
              (err: HttpErrorResponse) => {
                // console.log(error);
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                } 
                else if(err.error.statusCode == 422){
                  this.dashboardService.openSnackBar(err.error.message,"OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });
          } else {
            let payloaddata = {
              "PK_TranId": 0,
              "FK_RegId": this.opdvisitService.patientdetails.pkRegId,
              "OLDSummary": this.oldsummerydata +'\n'+ moment(JSON.parse(sessionStorage.getItem('SessiondateTime'))).format("DD/MM/YYYY, HH:mm")+' by '+ sessionStorage.getItem('userName'),
              "Remarks": null,
              "IsEdit": 0
            }
            this.emrService.insertOldSummery(payloaddata).subscribe(
              (data: any) => {
                if (data == null) {
                  throw 'Empty response';
                } else {
                  if (data.statusCode == 1) {

                    this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
                    this.getOldSummeryData();
                  }

                }
              },
              (err: HttpErrorResponse) => {
                // console.log(error);
                if (err.status == 403) {
                  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
                } 
                else if(err.error.statusCode == 422){
                  this.dashboardService.openSnackBar(err.error.message,"OK");
                }
                else {
                  this.dashboardService.openSnackBar("API Failed", "OK");
                }
              });
          }


        } catch (e) {
          console.log(e);
        }
      } else {
        this.dashboardService.openSnackBar("Please Select Patient", "OK");
      }


    } else {
      this.dashboardService.openSnackBar("Please Enter Old Case Summary", "OK");
    }

  }

  getOldSummeryData() {
    if (this.opdvisitService.patientdetails.pkRegId > 0) {
      this.getoldsummery = {};
      this.emrService.GetOldSummery(this.opdvisitService.patientdetails.pkRegId).subscribe(data => {
        this.getoldsummery = data;
      },err => {
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      });
    } else {
      this.dashboardService.openSnackBar("Please Select Patient", "OK");
    }
  }

}
